<template>
	<b-card no-body>
        
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <tire-size-create-or-update v-model="tireSize" :errors="errors"></tire-size-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="tire-size"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"></v-table>
    </b-card>
</template>

<script>
import {BCard,} from 'bootstrap-vue'
import TireSizeCreateOrUpdate from './components/TireSizeCreateOrUpdate.vue'
import VehicleDefinitionsApi from '@/api/vehicle-definitions'

export default {
	components:{
        BCard,
        TireSizeCreateOrUpdate
	},
	data(){
		return{
			editing:false,
            errors:{},
            loading:false,
            tireSize:{
                Id:null,
                Size:null,
                Description:null
            },
            fields:[
                { name:"Ölçü",key:"Size", thClass:"w-30",sortable:true},
                { name:"Açıklama",key:"Description", thClass:"w-70",sortable:true}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
		}
	},
	methods:{
		clearForm(){
            this.editing = false
            this.tireSize.Id = null
            this.tireSize.Size = null
            this.tireSize.Description = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.tireSize.Id = item.Id
            this.tireSize.Size = item.Size
            this.tireSize.Description = item.Description
            this.$showModal('create-or-update')
        },
        provider(data){
            return VehicleDefinitionsApi.TireSize.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            VehicleDefinitionsApi.TireSize.CreateOrUpdate(this.editing,this.tireSize)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Size} lastik ölçüsünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleDefinitionsApi.TireSize.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
	}
}
</script>

<style>

</style>